import { EnrollmentCard } from '@/components/services/enrollment-card';
import { EmptyState } from '@/components/ui/empty-state';
import { ErrorState } from '@/components/ui/error-state';
import { FadeInView } from '@/components/ui/fade-in-view';
import { PageLayout } from '@/components/ui/page-layout';
import { SkeletonCard } from '@/components/ui/skeleton';
import { useClientEnrollments } from '@/hooks/use-enrollments';
import React from 'react';
import { StaticList } from '@/components/ui/static-list';
import { View } from 'react-native';

export default function ClientEnrollmentsScreen() {
  const { data: enrollments, isLoading, error, refetch, fetchStatus } = useClientEnrollments();

  // Mostra loading apenas quando a query está efetivamente buscando (fetching).
  // Quando a query estiver desabilitada (ex: role não é CLIENT), o fetchStatus será "idle"
  // e não ficaremos presos eternamente no skeleton.
  if (isLoading || fetchStatus === 'fetching') {
    return (
      <PageLayout title="Meus Contratos" subtitle="Veja dados dos seus contratos ativos">
        <View className="gap-3">
          {Array.from({ length: 5 }).map((_, index) => (
            <SkeletonCard key={index} showHeader={true} showFooter={false} lines={2} />
          ))}
        </View>
      </PageLayout>
    );
  }

  if (error) {
    return (
      <View className="flex-1 bg-canvas p-5">
        <ErrorState
          variant="inline"
          title="Erro ao carregar contratos"
          message="Não foi possível carregar os contratos. Tente novamente."
          onRetry={refetch}
        />
      </View>
    );
  }

  return (
    <PageLayout title="Meus Contratos" subtitle="Veja dados dos seus contratos ativos">
      {!enrollments || enrollments.length === 0 ? (
        <EmptyState
          icon="document-text-outline"
          title="Nenhum contrato encontrado"
          description="Você ainda não possui contratos ativos."
          className="py-12"
        />
      ) : (
        <StaticList
          data={enrollments}
          keyExtractor={(item) => item.id}
          renderItem={(item, index) => (
            <FadeInView key={item.id} delay={index * 50}>
              <EnrollmentCard
                enrollment={item}
                size="large"
                basePath="/(tabs)/(client)/enrollments-client"
                variant="client"
              />
            </FadeInView>
          )}
        />
      )}
    </PageLayout>
  );
}
